import { gql } from '@apollo/client';
import React from 'react';
import { createContext } from 'react';
import {
  useActivityFeedBadgingQuery,
  useGetNewNotificationsSubscription,
} from './__generated__/ActivityFeedBadgingContext.generated';

export const ActivityFeedBadgingContext = createContext<{
  badgeCount: number;
}>({
  badgeCount: 0,
});

export function useActivityFeedBadgingContext() {
  return React.useContext(ActivityFeedBadgingContext);
}

export function useGetIsActivityFeedBadged() {
  const { data, loading, refetch } = useActivityFeedBadgingQuery();
  useGetNewNotificationsSubscription({
    onData: newData => {
      refetch();
    },
  });

  return { badgeCount: data?.getActivityFeedBadgeCount || 0 };
}

const query = gql`
  query ActivityFeedBadging {
    getActivityFeedBadgeCount
  }
  subscription GetNewNotifications {
    newAfNotification {
      id
    }
  }
`;
